export const baseUrl = "http://localhost:8080/https://cooltools-cold-breeze-873.fly.dev/"
//"http://cooltools-cold-breeze-873.fly.dev/";
